export default __webpack_public_path__ + "static/media/price.19483fa4.svg";